<p-toast />
@if (isLoading()) {
  <div class="flex flex-col gap-(--gap-relaxed) mb-(--space-4)">
    <div class="py-(--space-1) mb-(--space-4) flex gap-(--gap-normal) items-center flex-wrap">
      <ces-button-secondary size="small" [label]="'common.buttons.copyAllValues' | transloco" [disabled]="true" icon="content_copy" />
      <ces-button-secondary size="small" [label]="'common.buttons.plan' | transloco" [disabled]="true" icon="event" />
    </div>
    <ces-grid-skeleton [columns]="skeletonColumns()" [lines]="10" />
  </div>
} @else {
  <div cesFullscreen #fs="cesFullscreen">
    <div class="py-(--space-1) mb-(--space-4) flex gap-(--gap-normal) items-center flex-wrap justify-between">
      <div class="flex gap-(--gap-normal) items-center flex-wrap">
        <app-measure-column-toggle size="small" [value]="visibleColumns()" (visibilityChange)="onColumnVisibilityChange($event)" />
        <ces-button-secondary
          size="small"
          [label]="copyButtonLabel()"
          [disabled]="gridService.gridRowData().length === 0"
          icon="content_copy"
          (onClick)="onCopyAllValues()" />
        @if (selectedCellCount() > 0) {
          <ces-button-secondary
            size="small"
            [label]="'common.buttons.clearSelection' | transloco"
            icon="close"
            (onClick)="clearSelection()" />
        }
        @if (!isCampaignDone()) {
          <ces-button-secondary
            size="small"
            [label]="'common.buttons.plan' | transloco"
            icon="event"
            (onClick)="openPlanningDialog()" />
        }
      </div>
      <div class="flex gap-(--gap-normal) items-center">
        @if (hasActiveFilters()) {
          <ces-button-secondary
            size="small"
            icon="filter_alt_off"
            [label]="'common.buttons.clear' | transloco"
            (onClick)="clearAllFilters()" />
        }
        <ces-button-secondary
          size="small"
          [label]="fs.isFullscreen() ? ('common.buttons.exitFullscreen' | transloco) : ('common.buttons.fullscreen' | transloco)"
          [icon]="fs.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'"
          (onClick)="fs.toggle()" />
      </div>
    </div>
    <ag-grid-angular
      [localeText]="localeText"
      class="ag-theme-quartz w-full"
      [style.height]="fs.isFullscreen() ? 'calc(100vh - 60px)' : 'calc(100vh - 350px)'"
      [rowData]="gridService.gridRowData()"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (cellSelectionChanged)="onCellSelectionChanged()" />

    @if (!gridService.isReadOnly() && gridService.hasModifications()) {
      <ces-bottom-actions
        [cancelLabel]="'common.buttons.cancel' | transloco"
        [validateLabel]="'common.buttons.saveChanges' | transloco"
        [cancelDisabled]="!gridService.hasModifications()"
        [validateDisabled]="!gridService.hasModifications() || isSaving()"
        (discard)="onCancel()"
        (validate)="onSave()" />
    }
  </div>
}
